import React, { Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './work-skeleton.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import Bone from 'pobble-components/dist/bone'
import EntrySkeleton from './entry-skeleton/entry-skeleton'

const WorkSkeleton = ({ classes }) => (
  <Fragment>
    <Bone className={classes.mainTitle} />
    <Table>
      <thead>
        <tr>
          <HeadCell className={classes.dateCell}>
            <Bone className={classes.date} />
          </HeadCell>
          <HeadCell className={classes.titleCell}>
            <Bone className={classes.title} />
          </HeadCell>
        </tr>
      </thead>
      <tbody>
        <EntrySkeleton titleWidth={30} />
        <EntrySkeleton titleWidth={50} />
        <EntrySkeleton titleWidth={40} />
      </tbody>
    </Table>
  </Fragment>
)

export default injectSheet(styles)(WorkSkeleton)
